import { parseAsStringEnum, useQueryState } from 'nuqs'

export type SidebarTab = 'assets' | 'pipelines'

const sidebarTabParser = parseAsStringEnum<SidebarTab>(['assets', 'pipelines']).withDefault('assets')

export function useSidebarTab() {
  const [tab, setTab] = useQueryState('tab', sidebarTabParser)
  return { tab, setTab }
}
